module.exports = __webpack_public_path__ + "fonts/baronsans-thin-webfont.a90fc8de.woff2";